module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid7_1080x834.7a42d84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid7_1080x834.jpg
// module id = yfx5
// module chunks = 0